import { render, staticRenderFns } from "./GradeManagement.vue?vue&type=template&id=272582a2&"
import script from "./GradeManagement.vue?vue&type=script&lang=js&"
export * from "./GradeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports